import { ReactNode } from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

const SplitContentContainer = styled.div`
  ${tw`flex flex-col xl:flex-row`}
  column-gap: var(--size-small);
  row-gap: var(--size-medium);
`;

const SplitContentWrapper = styled.div`
  ${tw`flex flex-col xl:w-1/2`}
  gap:var(--size-medium);
`;

type SplitContentLayoutProps = {
  children: Array<ReactNode>;
};

export const SplitContentLayout = (props: SplitContentLayoutProps) => {
  const { children } = props;
  const halfLength = Math.ceil(children.length / 2);

  const leftItems = children.slice(0, halfLength);
  const rightItems = children.slice(halfLength);

  return (
    <SplitContentContainer>
      <SplitContentWrapper>{leftItems}</SplitContentWrapper>

      <SplitContentWrapper>{rightItems}</SplitContentWrapper>
    </SplitContentContainer>
  );
};
